<script lang="ts">
	import FormWithLabel from "../../molecules/FormWithLabel.svelte";
	import type { RecruitmentService } from "../../services/recruitment.service";

	export let service: RecruitmentService
	export let klass = ''
	const model = service.store.model
	const models = service.store.jobRoles
</script>

<div class="{klass}">
	<FormWithLabel
		label="担当業務"
		input={service.handleJobRoles}
		values={$model.jobRoles}
		inputType="checkboxes"
		options={$models}
	/>
</div>